import { CatalogImageBody } from "@/shared/gallery/api";

export const getSelectedImage = (
  gallery: CatalogImageBody[],
  catalog: string,
  postId: number
): number | undefined => {
  const catalogEntry = gallery.find(item => item.catalogue === catalog);
  if (!catalogEntry) return undefined;

  for (const image of catalogEntry.images) {
    if (image.post_id.includes(postId.toString())) {
      return image.id;
    }
  }

  return undefined;
};
